import { createAction } from '@ngrx/store'

export const unauthorizedError = createAction('[HttpError] Unauthorized Error 401')
